import React, { useState } from 'react'
import ModalTest from '../../../BaseModal'
import * as S from '../../../styles/modal-style'
import axios from '../../../../config/axios'
import copywhite from '../../../../assets/production-flow/copywhite.svg'
import cross from '../../../../assets/production-flow/cross.svg'

interface SplitOPModalProps {
  setModalActive: React.Dispatch<React.SetStateAction<number | null>>
  id: number
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
}

const SplitOPModal = ({setModalActive, id, setRefresh}: SplitOPModalProps) => {
  const [splitAmount, setSplitAmount] = useState<number>(2)
  
  const handleSplitOP = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/split`, {
        divideInto: splitAmount,
        opId: id
      })
      if(response.data) {
        setModalActive(null)
        setRefresh(prev => !prev)
      }
    } catch (_error) {
      console.error(_error)
    }
  }
  
  return (
    <ModalTest>
      <S.ContainerOfModal width='30rem'>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1rem'
        }}>
          <h3>Divisão de Ordem de Produção</h3>
          <button
            onClick={() => setModalActive(null)}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: 'none',
              background: '#f4f4f4',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              padding: 0
            }}
          >
            <img src={cross} alt="Fechar"/>
          </button>
        </div>
        <h4
          style={{
            fontSize: '12px',
            marginTop: '1rem'
          }}
        >Quantidade de novas OPs</h4>
        <S.Input 
          type="number" 
          value={splitAmount} 
          onChange={(e) => setSplitAmount(Number(e.target.value))} 
          placeholder='Digite aqui' 
          min={2} 
          style={{
            marginTop: '.5rem'
          }} 
        />
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'flex-end',
          marginTop: '2rem'
        }}>
          <button
            onClick={() => setModalActive(null)}
            style={{
              padding: '0.625rem 1.5rem',
              border: '1px solid #0090D3',
              background: 'transparent',
              color: '#0090D3',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '700'
            }}
          >Cancelar</button>
          <button
            onClick={handleSplitOP}
            style={{
              padding: '0.625rem 1.5rem', 
              border: 'none',
              background: '#0090D3',
              color: 'white',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <img src={copywhite} alt="Dividir"/>
            Dividir OP
          </button>
        </div>
      </S.ContainerOfModal>
    </ModalTest>
  )
}

export default SplitOPModal